module.exports = __webpack_public_path__ + "img/dds.3b7ccb51.svg";